/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Month_JuneInputs */

const he_month_june = /** @type {(inputs: Month_JuneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יוני`)
};

const en_month_june = /** @type {(inputs: Month_JuneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`June`)
};

/**
* | output |
* | --- |
* | "June" |
*
* @param {Month_JuneInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const month_june = /** @type {((inputs?: Month_JuneInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Month_JuneInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_month_june(inputs)
	return en_month_june(inputs)
});